import { Injector, Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { AbpMultiTenancyService } from '@abp/multi-tenancy/abp-multi-tenancy.service';
import { AbpSessionService } from '@abp/session/abp-session.service';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { LinkedAccountService } from '@app/shared/layout/linked-account.service';
import { AppConsts } from '@shared/AppConsts';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { ChangeUserLanguageDto, EmployeesServiceProxy, LinkedUserDto, ProfileServiceProxy, UserLinkServiceProxy, TenantDashboardServiceProxy, NewHireingOutput, AttendancesServiceProxy, GetPunchesForViewDto, ReviewStatusServiceProxy, API_BASE_URL, DropdownServicesServiceProxy, MarkAttendancesServiceProxy } from '@shared/service-proxies/service-proxies';
import * as _ from 'lodash';
import { PupUpMarkattendanceComponent } from '@app/main/markattendance/pup-up-markattendance/pup-up-markattendance.component';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PunchFailureCountComponent } from '../../main/punch-failure-count/punch-failure-count.component';
import { CreateOrEditAssetComponent } from '@app/main/asset/create-or-edit-asset/create-or-edit-asset.component';
import { AknwledgeAssignAssestComponent } from '@app/main/aknwledge-assign-assest/aknwledge-assign-assest.component';
import { IFormattedUserNotification } from './notifications/UserNotificationHelper';

@Component({
    templateUrl: './topbar.component.html',
    selector: 'topbar',
    encapsulation: ViewEncapsulation.None
})


export class TopBarComponent extends ThemesLayoutBaseComponent implements OnInit {

    isHost = false;
    languages: abp.localization.ILanguageInfo[];
    currentLanguage: abp.localization.ILanguageInfo;
    isImpersonatedLogin = false;
    isMultiTenancyEnabled = false;
    shownLoginName = '';
    tenancyName = '';
    userName = '';
    Name = '';
    profilePicture = ''//AppConsts.appBaseUrl + '/assets/common/images/default-profile-picture.png';
    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    recentlyLinkedUsers: LinkedUserDto[];
    unreadChatMessageCount = 0;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    chatConnected = false;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    adminuser: boolean = false;
    advanceRequests: number;
    AdminconformationPending: number = 0;
    newHire: NewHireingOutput[];
    punchCount: number;
    noPunch: boolean = true;
    evenPunch: boolean = false;
    oddPunch: boolean = false;
    punchdata: GetPunchesForViewDto[];
    len: number;
    minFormDateDateFilter: moment.Moment;
    maxToDateDateFilter: moment.Moment;
    // buttonText = 'New Review';
    reviewID: number;
    working_hours: string = "";
    baseUrl: string;
    remoteUrl = AppConsts.remoteServiceBaseUrl;
    tenancyLogo: any;
    punchFailureCount: any;
    @ViewChild('punchFailure', { static: true }) punchFailure: PunchFailureCountComponent;
  @ViewChild('createOrEditAsset', { static: true }) createOrEditAsset: AknwledgeAssignAssestComponent;

    constructor(
        private router: Router,
        injector: Injector,
        private _attendancesServiceProxy: AttendancesServiceProxy,
        private _dropdownServiceProxy: DropdownServicesServiceProxy,
        private _markAttendanceAppSeriveProxy: MarkAttendancesServiceProxy,
        private _abpSessionService: AbpSessionService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _impersonationService: ImpersonationService,
        private _linkedAccountService: LinkedAccountService,
        private _dashboardService: TenantDashboardServiceProxy,
        private _attendanceServiceProxy: AttendancesServiceProxy,
        private _employee: EmployeesServiceProxy,
        private _reviewStatusServiceProxy: ReviewStatusServiceProxy,
        @Inject(API_BASE_URL) baseUrl?: string
    ) {

        super(injector);
    }

    workingSeconds: number = 0;
    isTimerRunning: boolean = false;
    lastSyncedTime: number = 0; // timestamp in ms

    intervalId: any;


    ngOnInit() {
        //this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.isHost = !this._abpSessionService.tenantId;
        this.isMultiTenancyEnabled = this._abpMultiTenancyService.isEnabled;
        this.languages = _.filter(this.localization.languages, l => (l).isDisabled === false);
        this.currentLanguage = this.localization.currentLanguage;
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;
        this.setCurrentLoginInformations();
        this.getProfilePicture();
        this.getRecentlyLinkedUsers();
        this.registerToEvents();
        this.getTenancyLogo();
        this.minFormDateDateFilter = moment().startOf('day');
        this.maxToDateDateFilter = moment().startOf('day');
        if (this.appSession.user.userName == 'admin') {
            this.adminuser = true;
        }
        if (this.isHost == false) {
            this.reload();
            this.getCountPunch();
            this.getPunchFailureCount();
        }
        this.loadWorkingHours();

        this.intervalId = setInterval(() => {
            if (this.isTimerRunning) {
                this.displayWorkingHours();
            }
        }, 1000);

    }

    ngOnDestroy(): void {
        if (this.intervalId) clearInterval(this.intervalId);
    }
openAssetModal(data: { assetId: number; type?: 'A' | 'R'; userNotification?: IFormattedUserNotification }) {
    console.log("Asset Data :-", data);

    // Trigger the event with full data including userNotification
    abp.event.trigger('app.show.createOrEditAsset', data);
}



    getTenancyLogo() {
        this._dropdownServiceProxy.getBranchLogo().subscribe(result => {
            if (result != "") {
                this.tenancyLogo = AppConsts.ftpUrl + "/logoImage/" + result;
                // console.log(this.tenancyLogo + ' tenancyLogo');
            }
            // console.log(this.tenancyLogo + ' tenancyLogo outside');
        })
    }
    getPunchFailureCount() {
        this._markAttendanceAppSeriveProxy.punchFailureCount().subscribe(result => {
            this.punchFailureCount = result;

        });


    }

    showEmployeeData() {

    }
   getCountPunch() {
    const currentHour = moment().hour();

    
    if (currentHour >= 0 && currentHour < 6) {
        this.minFormDateDateFilter = moment().subtract(1, 'days').startOf('day');
    } else {
        this.minFormDateDateFilter = moment().startOf('day');
    }
    this.maxToDateDateFilter = moment().startOf('day');

    this._attendanceServiceProxy.viewPunches(
        this.minFormDateDateFilter,
        this.maxToDateDateFilter,
        this.appSession.Employeeid
    ).subscribe(result => {
        this.punchdata = result;
        this.len = this.punchdata.length;

        if (this.len == 0) {
            this.noPunch = true;
            this.evenPunch = false;
            this.oddPunch = false;
        } else if (this.len % 2 == 0) {
            this.noPunch = false;
            this.evenPunch = true;
            this.oddPunch = false;
        } else {
            this.noPunch = false;
            this.evenPunch = false;
            this.oddPunch = true;
        }
    });
}


    reload() {
        this.getCountPunch();
        if (this.appSession.user.userName != 'admin') {
            this._dashboardService
                .advanceRequests()
                .subscribe(result => {
                    this.advanceRequests = result;
                    //console.log"New hreing", this.newHire)

                });
        }
        else {
            this._dashboardService
                .adminAdvanceRequest()
                .subscribe(result => {
                    this.AdminconformationPending = result;
                    //console.log"New hreing", this.newHire)

                });
        }
    }
    AdvanceEmployee(): void {

        if (this.appSession.user.userName == 'admin') {
            this.notify.info("Admin Not Allowed To Take Any action")
            return;
        }

        this.router.navigateByUrl('app/main/requestForApproval/requestForApprovals');
    }

    registerToEvents() {
        abp.event.on('profilePictureChanged', () => {
            this.getProfilePicture();
        });

        abp.event.on('app.chat.unreadMessageCountChanged', messageCount => {
            this.unreadChatMessageCount = messageCount;
        });

        abp.event.on('app.chat.connected', () => {
            this.chatConnected = true;
        });

        abp.event.on('app.getRecentlyLinkedUsers', () => {
            this.getRecentlyLinkedUsers();
        });

        abp.event.on('app.onMySettingsModalSaved', () => {
            this.onMySettingsModalSaved();
        });
    }

    changeLanguage(languageName: string): void {
        const input = new ChangeUserLanguageDto();
        input.languageName = languageName;

        this._profileServiceProxy.changeLanguage(input).subscribe(() => {
            abp.utils.setCookieValue(
                'Abp.Localization.CultureName',
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );

            window.location.reload();
        });
    }

    setCurrentLoginInformations(): void {

        this.shownLoginName = this.appSession.getShownLoginName();
        this.tenancyName = this.appSession.tenancyName;
        this.tenant.name = this.appSession.tenant.name;
        this.userName = this.appSession.user.userName;
        this.Name = this.appSession.user.name;
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (linkedUser.tenantId ? linkedUser.tenancyName : '.') + '\\' + linkedUser.username;
    }

    getProfilePicture(): void {
        this._employee.getEmployeeProfilePictureWithoutFTP().subscribe(result => {
            debugger
            this.profilePicture = AppConsts.ftpUrl + "/" + result;

        });
    }

    getRecentlyLinkedUsers(): void {
        this._userLinkServiceProxy.getRecentlyUsedLinkedUsers().subscribe(result => {
            this.recentlyLinkedUsers = result.items;
        });
    }


    showLoginAttempts(): void {
        abp.event.trigger('app.show.loginAttemptsModal');
    }

    showLinkedAccounts(): void {
        abp.event.trigger('app.show.linkedAccountsModal');
    }


    // tenancynotification = null;
    // showInactiveTenancyAlert() {
    //     this._dashboardService.showInActiveTenancyNotification().subscribe(message => {
    //         if (message !== null)
    //             this.tenancynotification = message
    //     })
    // }


    changeSttandance(): void {
        debugger
        abp.event.trigger('app.show.pupUpMarkattendance'); // Triggering event


    }
    changePunchFailure(): void {
        debugger
        abp.event.trigger('app.show.punchFailure'); // Triggering event


    }

    //  getButtonText(){
    //     this._reviewStatusServiceProxy.checkPendingReviewForEmployeeForPopUP().subscribe(result=>{
    //         if(result != null || result.length != 0)
    //         {
    //           this.buttonText = result[0].buttonText;
    //           this.reviewID = result[0].reviewId;
    //         }

    //        });
    //  }
    showReview(): void {
        abp.event.trigger('app.show.employeeReviewPopUp', this.reviewID);
    }

    changePassword(): void {
        abp.event.trigger('app.show.changePasswordModal');
    }
    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    changeMySettings(): void {
        abp.event.trigger('app.show.mySettingsModal');
    }

    logout(): void {

        this._authService.logout();
    }

    onMySettingsModalSaved(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(linkedUser.id, linkedUser.tenantId);
    }

    downloadCollectedData(): void {
        this._profileServiceProxy.prepareCollectedData().subscribe(() => {
            this.message.success(this.l('GdprDataPrepareStartedNotification'));
        });
    }

    // createMarkAttendance(): void {

    //     this.markattendance.show();        
    // }
    MyProfilePicture() {
        //
        this.router.navigateByUrl('app/main/myprofileemployee/myprofileemployee/' + 0);
    }

    loadWorkingHours(): void {
        this._attendancesServiceProxy.getWorkingHours().subscribe((result) => {
            // Step 1: Remove milliseconds from string
            const cleanTime = result.hours.split('.')[0]; // e.g., "00:05:41"

            // Step 2: Convert hh:mm:ss to seconds
            const [hh, mm, ss] = cleanTime.split(':').map(Number);
            this.workingSeconds = hh * 3600 + mm * 60 + ss;

            this.lastSyncedTime = Date.now(); // current timestamp in ms


            // Step 3: Check if timer should keep running
            this.isTimerRunning = result.isTimerRunning;

            // Step 4: Display clean time
            this.displayWorkingHours();
        });
    }

    displayWorkingHours(): void {
        const now = Date.now();
        const elapsedSeconds = Math.floor((now - this.lastSyncedTime) / 1000);
        const totalSeconds = this.workingSeconds + elapsedSeconds;

        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        this.working_hours = `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;

    }


    pad(n: number): string {
        return n.toString().padStart(2, '0');
    }


}
